// Pure shaping for the owner's group view: the per-site rollup and the daily work queue, side by side.
// No fetching here, so it can be tested without a DOM. "Missing is not zero" holds throughout: an unread
// queue source withholds the count rather than showing 0.

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/** Sites ranked by revenue, each with its share of the group and a flag for "this one needs a look". */
export function rankSites(rollup) {
  const sites = Array.isArray(rollup?.locations) ? rollup.locations : [];
  const total = num(rollup?.total_revenue);
  return sites
    .map((s) => ({
      id: s.location_id,
      name: s.location_name || s.location_id,
      revenue: s.total_revenue,
      orders: num(s.order_count),
      aov: s.average_order_value,
      stockValue: s.stock_value,
      stockItems: num(s.stock_items),
      alerts: num(s.open_alerts),
      // A kitchen makes no till sales; its figure is stock, not revenue.
      sells: num(s.order_count) > 0,
      share: total > 0 ? Math.round((num(s.total_revenue) / total) * 100) : 0,
    }))
    .sort((a, b) => num(b.revenue) - num(a.revenue) || a.name.localeCompare(b.name));
}

/** Queue summary that never turns an unread source into a zero. */
export function queueSummary(queue) {
  if (!queue) return { known: false, count: null, unread: [], items: [] };
  const coverage = queue.coverage || {};
  const unread = coverage.sources_unavailable || [];
  const complete = coverage.complete !== false && unread.length === 0;
  const items = Array.isArray(queue.exceptions) ? queue.exceptions : [];
  return { known: complete, count: complete ? items.length : null, unread, items: items.slice(0, 6) };
}

/** Where an exception is worked, so a card is a doorway and not a dead end. */
export function exceptionLink(e) {
  switch (e?.kind) {
    case 'review': return '/receiving/reviews';
    case 'send': return '/receiving/claims';
    case 'alert': return '/alerts';
    case 'approval': return '/procurement';
    case 'control': return '/controls';
    case 'missed_check': return '/safety';
    default: return '/owner/queue';
  }
}
